import {ADMIN_SERVER} from "../constants/GlobalConst";
import {refreshAdmin} from "../services/auth/AuthAxios";
import createAuthenticatedAxios from "./createAuthenticatedAxios";

export const adminAxios=createAuthenticatedAxios({
  baseURL:ADMIN_SERVER,refreshSession:refreshAdmin,refreshErrorMessage:'관리자 인증 갱신에 실패했습니다.',
  toSession:data=>({id:data.email,role:data.role,name:data.name,accessToken:data.token.accessToken,refreshToken:data.token.refreshToken,username:'',serverName:ADMIN_SERVER}),
});
